module.exports = __webpack_public_path__ + "static/media/search.d9373f49.svg";